import { defineComponent } from 'vue'

import Translation from '../Translation'

export default defineComponent({
	name: 'SiteFooter',

	render() {
		return (
			<footer>
				<nav class="site-footer">
					<span class="site-footer-text">
						<Translation args={{ year: new Date().getFullYear() }} tag="span" tKey="footer.copyWrite" />
					</span>
					<span class="site-footer__links">
						<Translation tag="a" tKey="footer.medicalDisclaimer" {...{ href: 'https://careacademy.com/medical-disclaimer/', target: '_blank' }} />
						<Translation tag="a" tKey="footer.termsOfService" {...{ href: 'https://careacademy.com/terms-of-service/', target: '_blank' }} />
						<Translation tag="a" tKey="footer.privacyPolicy" {...{ href: 'https://careacademy.com/privacy-policy/', target: '_blank' }} />
					</span>
				</nav>
			</footer>

		)
	},
})
